module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_05-2533eb01338597c17a53f551fd8d11f5.png";